// extracted by mini-css-extract-plugin
module.exports = {"docsPanel":"style_docsPanel__3CjAS","shower":"style_shower__2Az5L","modalDocument":"style_modalDocument__2TR53","document":"style_document__cDQaB","docs":"style_docs__3iNhE"};